// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "audit_log".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { auditActionValues, auditActorTypeValues } from '@borradh-workspace/labels';
/** Response atom for the "audit_log" table (1:1 with a DB row, on the wire). */
export const auditLogAtomSchema = z.object({
    id: z.string(),
    action: z.enum(auditActionValues),
    entityType: z.string(),
    entityId: z.string(),
    actorType: z.enum(auditActorTypeValues),
    actorId: z.string().nullable(),
    organizationId: z.string(),
    metadata: z.unknown().nullable(),
    createdAt: z.string().datetime(),
});
//# sourceMappingURL=auditLog.js.map